import * as types from "../action/ActionType";
import { CHECK_USER_INITIAL } from "../store/InitialStore";
export default function CheckUserReducer(state = CHECK_USER_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.CHECK_USER:
      return (state = payload);
    default:
      return state;
  }
}
